import { actionTypes } from "../actions/default.action"

const initialState = {
  productFunctionalities: {
    data: [],
  },
  productFunctionality: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        productFunctionalities: {
          ...state.productFunctionalities,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        productFunctionalities: {
          ...state.productFunctionalities,
          data: state.productFunctionalities.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        productFunctionality: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
